// ── useTracer hook ──────────────────────────────────────────────────────────
// Returns an MFE-scoped OTEL Tracer from the ObservabilityProvider context.

import { useObservability } from './ObservabilityProvider';

/**
 * Returns the OTEL Tracer for the current MFE scope.
 *
 * Returns `null` if OTEL is not initialized (e.g., in tests).
 */
export function useTracer() {
  const {
    tracer
  } = useObservability();
  return tracer;
}